export default "__VITE_ASSET__j2$sxRJ8__"